<template>
  <v-card class="elevation-0 mt-0" flat>
    <v-card-title>Seus Cartões</v-card-title>
    <v-card-text style="padding-bottom: 0">
      <v-progress-linear v-if="loading" indeterminate></v-progress-linear>
      <div class="cards-flex">
        <v-card
          v-for="item in cards"
          :key="item.id"
          :class="
            item.active && cards.length > 1
              ? 'active-card credit-cards'
              : 'credit-cards'
          "
        >
          <div class="card-infos">
            <v-img
              :src="getCardFlagIcon(item.card_flag)"
              max-width="100px"
              max-height="70px"
              class="flag-icon"
            >
            </v-img>
            <div>
              <p class="text-uppercase font-weight-bold text-subtitle-2 mb-1">
                {{ item.card_flag }} •••• {{ item.card_last_4digits }}
              </p>
              <p class="text--disabled text-subtitle-2">
                Validade: {{ item.card_expiration_date }}
              </p>
            </div>
          </div>
          <v-card-actions class="pb-0">
            <v-spacer></v-spacer>
            <v-btn text small color="secondary" @click="deleteCard(item.id)">
              remover
            </v-btn>
          </v-card-actions>
        </v-card>
      </div>
    </v-card-text>
    <v-card-actions>
      <v-btn
        rounded
        color="primary"
        class="mt-2 mx-2 pr-3"
        :disabled="loading"
        @click="is_registering = !is_registering"
      >
        <v-icon> add </v-icon>
        Adicionar cartão
      </v-btn>
    </v-card-actions>
    <v-dialog v-model="is_registering" max-width="900">
      <v-toolbar dense>
        <v-toolbar-title>Cartão de Crédito</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="is_registering = !is_registering">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <credit-card
        class="pa-3"
        :advice="'R$ 1,23 irão ser cobrados e restornados para verificar o cartão.'"
        :disabled="loading"
        :showEndButton="true"
        @end="cardEnd"
      />
    </v-dialog>
  </v-card>
</template>

<script>
import visa from "../../../../../assets/icons/visa.svg";
import elo from "../../../../../assets/icons/elo.svg";
import mastercard from "../../../../../assets/icons/mastercard.svg";
import amex from "../../../../../assets/icons/amex.svg";
import generic from "../../../../../assets/icons/generic.svg";
import { CONFIG } from "../../../config";
import CreditCard from "../../../pages/shop/CreditCard.vue";
import UserService from "@/services/users.service";

export default {
  components: { CreditCard },
  data() {
    return {
      headers: [
        {
          text: "Últimos 4 Dígitos",
          align: "start",
          sortable: false,
          value: "digitos",
        },
        { text: "Bandeira", value: "bandeira" },
        { text: "Ações", value: "acoes", align: "end" },
      ],
      cards: [],
      is_registering: false,
      loading: false,
      visa,
      mastercard,
      amex,
      elo,
      generic,
    };
  },
  mounted() {
    this.loadCards();
  },
  methods: {
    getCardFlagIcon(flag) {
      switch (flag.toLowerCase()) {
        case "visa":
          return this.visa;
        case "mastercard":
          return this.mastercard;
        case "amex":
          return this.amex;
        case "elo":
          return this.elo;
        default:
          return this.generic;
      }
    },
    async deleteCard(id) {
      this.loading = true;
      try {
        await UserService.deleteCard({ id });
        await this.loadCards();
        window.getApp.sendSnackMessage(
          "Cartão removido com sucesso!",
          "success",
        );
      } catch (error) {
        if (error.response && error.response.status === 500) {
          window.getApp.sendSnackMessage(
            "Erro ao tentar deletar o cartão!",
            "error",
          );
        } else {
          window.getApp.sendSnackMessage(
            "Um erro ocorreu ao tentar deletar o seu cartão!",
            "error",
          );
        }
      } finally {
        this.loading = false;
      }
    },
    async loadCards() {
      this.loading = true;
      try {
        const { data } = await UserService.getCards();
        this.cards = data.map((card) => ({
          card_last_4digits: card.last_digits,
          card_flag: card.brand,
          id: card.id,
          active: card.active,
          card_expiration_date:
            (card.expiration_month ?? "00") +
            "/" +
            (card.expiration_year ?? "0000"),
        }));
      } catch (error) {
        if (error.response && error.response.status === 500) {
          window.getApp.sendSnackMessage(
            "Um erro ocorreu ao tentar cadastrar seu cartão!",
            "error",
          );
        } else {
          window.getApp.sendSnackMessage("Erro ao carregar cartões!", "error");
        }
      } finally {
        this.loading = false;
      }
    },
    async cardEnd(card) {
      this.loading = true;
      try {
        const token = await window.grecaptcha.execute(CONFIG.CAPTCHA_SITE_KEY, {
          action: "submit",
        });
        await UserService.addCard(
          {
            card_holder_name: card.cardName,
            card_number: card.cardNumber.replace(/\s/g, ""),
            card_expiration_date:
              card.cardMonth + card.cardYear.toString().slice(2),
            card_cvv: card.cardCvv,
          },
          token,
        );
        await this.loadCards();
        this.is_registering = false;
        window.getApp.sendSnackMessage(
          "Cartão cadastrado com sucesso!",
          "success",
        );
      } catch (error) {
        if (error.response && error.response.status === 500) {
          window.getApp.sendSnackMessage(
            "Problemas no Servidor, tente novamente mais tarde!",
            "error",
          );
        } else if (error.response && error.response.status === 422) {
          window.getApp.sendSnackMessage(error.response.data.message, "error");
        } else {
          console.error(error);
          window.getApp.sendSnackMessage(
            "Um erro ocorreu ao tentar cadastrar seu cartão!",
            "error",
          );
        }
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.cards-flex {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 16px;
}
.active-card {
  order: -1;
  border: 1px solid var(--v-primary-base) !important;
}
.credit-cards {
  display: flex;
  flex-direction: column;
  font-size: 14px;
  padding: 10px;
  gap: 16px;
  width: 48%;
  border-radius: 5px;
  @media screen and (max-width: 700px) {
    width: 100%;
  }
}
.card-infos {
  display: flex;
  flex-wrap: nowrap;
  gap: 16px;
  margin-top: 10px;
}
.flag-icon {
  border-radius: 5px;
}
</style>
